import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as e } from "react/jsx-runtime";
import r from "styled-components";
import { ColorTokens as a } from "@vds-tokens/color";
var l = a.elements.primary.onlight.value,
  o = a.elements.primary.ondark.value,
  t = r.ul.withConfig({
    displayName: "StyledUl",
    componentId: "VDS__sc-1lyo7kf-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  li,\n  ul li {\n    color: ", " !important;\n  }\n"])), function (_ref) {
    var e = _ref.surface;
    return "dark" === e ? o : l;
  }),
  i = function i(r) {
    var a = r.id,
      l = r.children,
      o = r.className,
      i = r.surface,
      n = r.ariaLabel;
    return e(t, {
      id: a,
      className: o,
      surface: i,
      "aria-label": n,
      children: l
    });
  };
i.defaultProps = {
  surface: "light"
}, i.displayName = "UnorderedList";
export { i as default };